import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { DateInputComponent } from '../../inputs/date-input/date-input.component';
import { FormErrorComponent } from '../../form-error/form-error.component';

@Component({
  selector: 'lib-date-form-field',
  imports: [ReactiveFormsModule, DateInputComponent, FormErrorComponent],
  templateUrl: './date-form-field.component.html',
  styleUrl: './date-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  readonly minDate = input<string | undefined>();
  readonly maxDate = input<string | undefined>();
  readonly useFutureYearOptions = input<boolean>(false);
  inputId: string = uuidv4();
}
